var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "f_logo_RGB-White_1024") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "-1.27899982e-15 0 24 0 24 24 -1.27899982e-15 24"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NewLeadGen_4-/-XS-<576px",
    transform: "translate(-75.000000, -523.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f_logo_RGB-White_1024",
    transform: "translate(75.000000, 523.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12.0733361 C24,5.40541178 18.6274219,0 12,0 C5.37257813,0 0,5.40541178 0,12.0733361 C0,18.0994871 4.38822656,23.094264 10.125,24 L10.125,15.5632848 L7.078125,15.5632848 L7.078125,12.0733361 L10.125,12.0733361 L10.125,9.41342923 C10.125,6.38754937 11.9165156,4.71614691 14.6575781,4.71614691 C15.9704766,4.71614691 17.34375,4.95195425 17.34375,4.95195425 L17.34375,7.92312681 L15.8305781,7.92312681 C14.3398828,7.92312681 13.875,8.85378766 13.875,9.8085716 L13.875,12.0733361 L17.203125,12.0733361 L16.6710938,15.5632848 L13.875,15.5632848 L13.875,24 C19.6117734,23.094264 24,18.0994871 24,12.0733361",
    id: "Fill-1",
    fill: "#2460D8",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.bc84fc090d7c116b6b015cd6dc81bfd7.svg";
export { ForwardRef as ReactComponent };